module.exports = __webpack_public_path__ + "static/media/1_portfolio_site_bookcovers_1.7cdf3e20.png";